export class Seccion {

    SeccionID: number;
    Nombre : string;
    

  }